import React from "react";
import { Link } from "react-router-dom";
import "./DesktopBannerSlider.css";

const banners = [
  {
    alt: "Bank of India loan offer",
    file: "Bank Of India.png",
  },
  {
    alt: "Bank of Baroda loan offer",
    file: "Bank Of Baroda.png",
  },
  {
    alt: "ICICI Bank loan offer",
    file: "ICICI bank.png",
  },
  {
    alt: "Bank of Maharashtra loan offer",
    file: "Bank Of Maharashtra.png",
  },
  {
    alt: "Central Bank of India loan offer",
    file: "central bank of india.png",
  },
  {
    alt: "State Bank of India loan offer",
    file: "SBI Bank.png",
  },
  {
    alt: "IDBI Bank loan offer",
    file: "IDBI Bank.png",
  },
  {
    alt: "HDFC Bank loan offer",
    file: "HDFC Bank.png",
  },
  {
    alt: "Indian Overseas Bank loan offer",
    file: "Indian overseas Bank.png",
  },
];

const DesktopBannerSlider = () => {
  return (
    <section
      className="desktop-banner-section"
      aria-label="Monayra bank loan offers"
    >
      <div className="desktop-banner-glow desktop-banner-glow-left"></div>
      <div className="desktop-banner-glow desktop-banner-glow-right"></div>

      <div className="desktop-banner-container">
        <div
          id="elementorBannerSliderDesktop"
          className="carousel slide carousel-fade desktop-banner-carousel"
          data-bs-ride="carousel"
          data-bs-interval="5000"
          data-bs-pause="hover"
          data-bs-touch="true"
        >
          <div className="carousel-indicators desktop-banner-indicators">
            {banners.map((banner, index) => (
              <button
                key={banner.file}
                type="button"
                data-bs-target="#elementorBannerSliderDesktop"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`View banner ${index + 1}`}
              />
            ))}
          </div>

          <div className="carousel-inner desktop-banner-carousel-inner">
            {banners.map((banner, index) => (
              <div
                key={banner.file}
                className={`carousel-item desktop-banner-item ${
                  index === 0 ? "active" : ""
                }`}
              >
                <Link
                  to="/apply-now"
                  className="desktop-banner-link"
                  aria-label={`Apply for ${banner.alt}`}
                >
                  <div className="desktop-banner-image-wrapper">
                    <img
                      src={`/images/Banner-Desktop/${banner.file}`}
                      className="desktop-banner-image"
                      alt={banner.alt}
                      loading={index === 0 ? "eager" : "lazy"}
                      fetchPriority={index === 0 ? "high" : "auto"}
                    />

                    <div className="desktop-banner-overlay"></div>

                    <div className="desktop-banner-bottom-bar">
                      <div className="desktop-banner-trust">
                        <span className="desktop-banner-trust-icon">
                          <i className="bi bi-shield-check"></i>
                        </span>

                        <div>
                          <strong>Trusted Loan Assistance</strong>
                          <span>Compare offers from leading banks</span>
                        </div>
                      </div>

                      <span className="desktop-banner-apply-button">
                        Explore Offer
                        <i className="bi bi-arrow-up-right"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev desktop-banner-control desktop-banner-control-prev"
            type="button"
            data-bs-target="#elementorBannerSliderDesktop"
            data-bs-slide="prev"
            aria-label="Previous loan offer"
          >
            <span className="desktop-banner-control-icon" aria-hidden="true">
              <i className="bi bi-chevron-left"></i>
            </span>

            <span className="visually-hidden">Previous</span>
          </button>

          <button
            className="carousel-control-next desktop-banner-control desktop-banner-control-next"
            type="button"
            data-bs-target="#elementorBannerSliderDesktop"
            data-bs-slide="next"
            aria-label="Next loan offer"
          >
            <span className="desktop-banner-control-icon" aria-hidden="true">
              <i className="bi bi-chevron-right"></i>
            </span>

            <span className="visually-hidden">Next</span>
          </button>

          <div className="desktop-banner-progress">
            <span></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesktopBannerSlider;